const T = "BRAND", N = "LOCATION";
var E = /* @__PURE__ */ ((I) => (I.VERIFICATION_STATE_UNSPECIFIED = "VERIFICATION_STATE_UNSPECIFIED", I.VERIFIED = "VERIFIED", I.UNVERIFIED = "UNVERIFIED", I.VERIFICATION_REQUESTED = "VERIFICATION_REQUESTED", I))(E || {});
export {
  T as BRAND_TYPE,
  E as GoogleVerificationStateEnum,
  N as LOCATION_TYPE
};
